<template>
  <div class="heading">
    <div class="heading heading__logo" @click="$emit('home')">
      <img v-if="!isHkom" src="@/assets/logo.svg" alt="logo">
      <img v-else src="@/assets/logo_green.svg" alt="logo">
    </div>
    <div class="heading__right">
      <div class="heading__locale-container">
        <v-select
          :options="langs"
          label="name"
          :reduce="lang => lang.code"
          :clearable="false"
          :searchable="false"
          @option:selected="switchLang"
          v-model="$i18n.locale"
          :components="{OpenIndicator}"
          >
            <template slot="option" slot-scope="lang">
              <img class="heading__locale-country" :src="require(`@/assets/icons/${lang.code}.svg`)">
            </template>
            <template slot="selected-option" slot-scope="lang">
              <img class="heading__locale-country" :src="require(`@/assets/icons/${lang.code}.svg`)">
            </template>
          </v-select>
      </div>
      <span v-if="uporabnik" class="heading__user">
        <a href="/zgodovina-prenosov"
          :class="!$store.state.isHkom ? 'text-primary' : 'text-primary--green'">{{uporabnik.ime}} {{uporabnik.priimek}}</a>
        <span v-if="uporabnik.sicas">
          | <a href="/logout"
            :class="!$store.state.isHkom ? 'text-primary' : 'text-primary--green'">{{ $t('Logout') }}</a>
        </span>
      </span>
    </div>

    <h1 class="heading heading--primary">{{$t('title')}}</h1>
    <h2 class="heading heading--subtitle">{{ subtitle }}</h2>
  </div>
</template>

<script>
import { getSupportedLocales } from '../../i18n'

export default {
  name: "AppHeading",
  data() {
    return {
      state: this.$store.state,
      langs: getSupportedLocales(),
      OpenIndicator: {
        render: createElement => createElement('span', {class: {'toggle': true}})
      }
    }
  },
  props: {
    subtitle: {
      type: String,
      default: function () {
        return this.$t('headingSubtitle')
      }
    },
  },
  computed: {
    isHkom() {
      return this.$store.state.isHkom || false
    },
    uporabnik() {
      return this.$store.state.uporabnik
    },
  },
  methods: {
    switchLang (lang) {
      this.$store.setLang(lang.code)
      this.$http.post('/language?lang=' + lang.code, {
        credentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(response => {
      }, response => {
        // error
      })
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/sass/bootstrap/variables";

.heading {
  text-align: center;
  position: relative;

  &--primary {
    color: #000000;
    margin-top: 20px;
    margin-bottom: 0;
    line-height: normal;
}

  &--subtitle {
    color: #aeaeae;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    margin-bottom: 62px;

    @media (max-width: $screen-sm) {
      margin-bottom: 20px;
    }
  }

  &__logo {
    cursor: pointer;
    width: 175px;
    height: 100px;
    margin: 0 auto;
  }

  &__right {
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    align-items: center;

    @media (max-width: 676px) {
      flex-direction: column-reverse;
    }
  }

  &__locale-container {
    margin-right: 20px;
    position: relative;
    width: 65px;
  }

  &__locale-country {
    width: 20px;
  }

  &__locale-select {
    -webkit-appearance: none;
    appearance: none;
    padding: 3px 25px 3px 10px;
    border-radius: 50px;
    background-color: #fff;
    font-size: 14px;
    font-weight: 600;
  }

  &__user {

    font-weight: 600;
    font-size: 16px;

    &:hover {
      text-decoration: none;
    }
  }
}

// Override styles for vue-select
.v-select .vs__dropdown-toggle {
  border-radius: 50px !important;
  border-color: #575757;
}

.v-select .vs__dropdown-menu {
  min-width: 65px;
}

.v-select .vs__dropdown-toggle {
  &::after {
    content: url('../../assets/icons/dropdown.svg');
      width: 10px;
      height: 10px;
      font-size: 1rem;
      top: 7px;
      right: 10px;
      position: absolute;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/layout/AppHeading.vue